export enum Unit {
  Percent = 'percent',
  Amount = 'amount',
}
